import { render, staticRenderFns } from "./company-info-basic-display.vue?vue&type=template&id=128d6211&scoped=true&"
import script from "./company-info-basic-display.vue?vue&type=script&lang=js&"
export * from "./company-info-basic-display.vue?vue&type=script&lang=js&"
import style0 from "./company-info-basic-display.vue?vue&type=style&index=0&id=128d6211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d6211",
  null
  
)

export default component.exports